import { createClient } from "@supabase/supabase-js";

// ─── Feature flag ─────────────────────────────────────────────────────────────
// When VITE_SUPABASE_URL is set, the app reads/writes Supabase.
// Without it, the existing localStorage path continues to work unchanged.
// This lets Phase 1 and Phase 2 coexist during the migration transition.

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export function isSupabaseEnabled(): boolean {
  return Boolean(supabaseUrl && supabaseAnonKey);
}

// ─── Typed client ─────────────────────────────────────────────────────────────
// Created lazily — only instantiated when Supabase is enabled.
// Call isSupabaseEnabled() before using supabase to avoid runtime errors.

export const supabase = isSupabaseEnabled()
  ? createClient(supabaseUrl!, supabaseAnonKey!)
  : null;
